// Status colours for plot polygons — normal and selected (active) variants
export const STATUS_COLORS = {
  critical: '#f44336',
  warning:  '#ff9800',
  thriving: '#4caf50',
  neutral:  '#2196F3',
}

export const STATUS_COLORS_SELECTED = {
  critical: '#b71c1c',
  warning:  '#e65100',
  thriving: '#1b5e20',
  neutral:  '#0d47a1',
}

// Selected crop row border in the inspector table — matches the selected plot polygon stroke
export const SELECTED_ROW_BORDER = STATUS_COLORS_SELECTED.neutral
